import React, { Component } from "react";
import { Steps } from "antd";
import styled from "styled-components";

const Step = Steps.Step;

const CustomAntStep = styled(Steps)`
  && {
    .ant-steps-item-description {
      max-width: 100% !important;
    }
  }
`;

const H3 = styled.h3`
  text-align: center;
  margin-bottom: 25px;
`;

const titles = [
  { value: "head_start_operations_manager", title: "Operations Manager" },
  { value: "head_start_nutrition_manager", title: "Nutrition Manager" },
  {
    value: "head_start_health_family_manager",
    title: "Health & Family Manager"
  },
  {
    value: "head_start_ed_special_service_manager",
    title: "Ed & Special Service Manager"
  },
  { value: "head_start_compliance_manager", title: "Compliance Manager" },
  { value: "head_start_center_manager", title: "Center Manager" },
  {
    value: "head_start_community_partnerships_manager",
    title: "Community Partnerships Manager"
  },
  {
    value: "head_start_head_start_senior_director",
    title: "Head Start Senior Director"
  },
  {
    value: "head_start_assistant_director_operations",
    title: "Head Start Assistant Director of Operations"
  },
  {
    value: "head_start_assistant_director_childcare_partnerships",
    title: "Head Start Assistant Director of Childcare Partnerships"
  },
  {
    value: "case_21_century_assistant_director",
    title: "CASE 21 Century Assistant Director"
  },
  {
    value: "case_partnership_assistant_director",
    title: "CASE Partnership Assistant Director"
  },
  {
    value: "case_city_of_houston_assistant_director",
    title: "CASE City of Houston Assistant Director"
  },
  {
    value: "case_endowment_assistant_director",
    title: "CASE Endowment Assistant Director"
  }
];

const getStepsByRole = (role, approvals) => {
  const currentStep = approvals.length;
  let submittedBy = "";

  if (
    titles.find(title => title.value === approvals[0]["approvingAuthority"])
  ) {
    submittedBy = titles.find(
      title => title.value === approvals[0]["approvingAuthority"]
    ).title;
  }

  switch (role) {
    case "AED_MANAGER_1":
    case "AED_MANAGER_2":
    case "AED_MANAGER_3":
    case "AED_MANAGER_4":
    case "AED_DIR_COMPLIANCE":
    case "HS_MANAGER_1":
    case "HS_DIR_COMPLIANCE":
    case "CASE_MANAGER_1":
    case "CASE_MANAGER_2":
    case "CASE_MANAGER_3":
    case "CASE_MANAGER_4":
    case "SAFE_MANAGER_1":
    case "SAFE_DIR_COMPLIANCE":
      if (currentStep > 0) {
        if (currentStep === 1) {
          return (
            <div>
              <H3>Approval Status</H3>
              <CustomAntStep current={1}>
                <Step title="Employee" description="Submitted by Employee" />
                <Step
                  title="Manager"
                  description="Awaiting Approval by Manager"
                />
                <Step
                  title="Director/Compliance Manager"
                  description="Awaiting by Director/Compliance Manager"
                />
              </CustomAntStep>
            </div>
          );
        } else if (currentStep === 2) {
          return (
            <div>
              <H3>Approval Status</H3>
              <CustomAntStep current={2}>
                <Step title="Employee" description="Submitted by Employee" />
                <Step title="Manager" description="Approved by Manager" />
                <Step
                  title="Director/Compliance Manager"
                  description="Awaiting Approval by Director/Compliance Manager"
                />
              </CustomAntStep>
            </div>
          );
        } else if (currentStep === 3) {
          return (
            <div>
              <H3>Approval Status</H3>
              <CustomAntStep current={3}>
                <Step title="Employee" description="Submitted by Employee" />
                <Step title="Manager" description="Approved by Manager" />
                <Step
                  title="Director/Compliance Manager"
                  description="Approved by Director/Compliance Manager"
                />
              </CustomAntStep>
            </div>
          );
        }
      }
      break;
    case "CASE_DIR_COMPLIANCE":
      if (currentStep > 0) {
        if (
          approvals.find(
            approval =>
              approval["approvingAuthority"] ===
                "case_21_century_assistant_director" ||
              approval["approvingAuthority"] ===
                "case_partnership_assistant_director" ||
              approval["approvingAuthority"] ===
                "case_city_of_houston_assistant_director" ||
              approval["approvingAuthority"] ===
                "case_endowment_assistant_director"
          )
        ) {
          if (currentStep === 1) {
            return (
              <div>
                <H3>Approval Status</H3>
                <CustomAntStep current={1}>
                  <Step
                    title={`${submittedBy}`}
                    description={`Submitted by ${submittedBy}`}
                  />
                  <Step
                    title="Director/Compliance Manager"
                    description="Awaiting by Director/Compliance Manager"
                  />
                </CustomAntStep>
              </div>
            );
          } else if (currentStep === 2) {
            return (
              <div>
                <H3>Approval Status</H3>
                <CustomAntStep current={2}>
                  <Step
                    title={`${submittedBy}`}
                    description={`Submitted by ${submittedBy}`}
                  />
                  <Step
                    title="Director/Compliance Manager"
                    description="Approved by Director/Compliance Manager"
                  />
                </CustomAntStep>
              </div>
            );
          }
        } else {
          if (currentStep === 1) {
            return (
              <div>
                <H3>Approval Status</H3>
                <CustomAntStep current={1}>
                  <Step title="Employee" description="Submitted by Employee" />
                  <Step
                    title="Manager"
                    description="Awaiting Approval by Manager"
                  />
                  <Step
                    title="Director/Compliance Manager"
                    description="Awaiting by Director/Compliance Manager"
                  />
                </CustomAntStep>
              </div>
            );
          } else if (currentStep === 2) {
            return (
              <div>
                <H3>Approval Status</H3>
                <CustomAntStep current={2}>
                  <Step title="Employee" description="Submitted by Employee" />
                  <Step title="Manager" description="Approved by Manager" />
                  <Step
                    title="Director/Compliance Manager"
                    description="Awaiting Approval by Director/Compliance Manager"
                  />
                </CustomAntStep>
              </div>
            );
          } else if (currentStep === 3) {
            return (
              <div>
                <H3>Approval Status</H3>
                <CustomAntStep current={3}>
                  <Step title="Employee" description="Submitted by Employee" />
                  <Step title="Manager" description="Approved by Manager" />
                  <Step
                    title="Director/Compliance Manager"
                    description="Approved by Director/Compliance Manager"
                  />
                </CustomAntStep>
              </div>
            );
          }
        }
      }
      break;

    case "HS_SENIOR_DIRECTOR":
      if (currentStep === 1) {
        return (
          <div>
            <H3>Approval Status</H3>
            <CustomAntStep current={1}>
              <Step
                title={submittedBy}
                description={`Submitted by ${submittedBy}`}
              />
              <Step
                title="Head Start Senior Director"
                description="Awaiting Approval by Head Start Senior Director"
              />
            </CustomAntStep>
          </div>
        );
      } else if (currentStep === 2) {
        return (
          <div>
            <H3>Approval Status</H3>
            <CustomAntStep current={2}>
              <Step
                title={submittedBy}
                description={`Submitted by ${submittedBy}`}
              />
              <Step
                title="Head Start Senior Director"
                description="Approved by Head Start Senior Director"
              />
            </CustomAntStep>
          </div>
        );
      }
      break;

    case "HS_OPS_MANAGER":
      if (currentStep > 0) {
        if (currentStep === 1) {
          return (
            <div>
              <H3>Approval Status</H3>
              <CustomAntStep current={1}>
                <Step
                  title="Center Manager"
                  description="Submitted by Center Manager"
                />
                <Step
                  title="Operations Manager"
                  description="Awaiting Approval by Operations Manager"
                />
                <Step
                  title="Assistant Director of Operations"
                  description="Awaiting Approval by Assistant Director of Operations"
                />
              </CustomAntStep>
            </div>
          );
        } else if (currentStep === 2) {
          return (
            <div>
              <H3>Approval Status</H3>
              <CustomAntStep current={2}>
                <Step
                  title="Center Manager"
                  description="Submitted by Center Manager"
                />
                <Step
                  title="Operations Manager"
                  description="Approved by Operations Manager"
                />
                <Step
                  title="Assistant Director of Operations"
                  description="Awaiting Approval by Assistant Director of Operations"
                />
              </CustomAntStep>
            </div>
          );
        } else if (currentStep === 3) {
          return (
            <div>
              <H3>Approval Status</H3>
              <CustomAntStep current={3}>
                <Step
                  title="Center Manager"
                  description="Submitted by Center Manager"
                />
                <Step
                  title="Operations Manager"
                  description="Approved by Operations Manager"
                />
                <Step
                  title="Assistant Director of Operations"
                  description="Approved by Assistant Director of Operations"
                />
              </CustomAntStep>
            </div>
          );
        }
      }
      break;

    case "HS_ASSISTANT_DIR_OPS":
      if (
        approvals.find(
          approver =>
            approver["approvingAuthority"] === "head_start_center_manager"
        )
      ) {
        if (currentStep > 0) {
          if (currentStep === 1) {
            return (
              <div>
                <H3>Approval Status</H3>
                <CustomAntStep current={1}>
                  <Step
                    title="Center Manager"
                    description="Submitted by Center Manager"
                  />
                  <Step
                    title="Operations Manager"
                    description="Awaiting Approval by Operations Manager"
                  />
                  <Step
                    title="Assistant Director of Operations"
                    description="Awaiting Approval by Assistant Director of Operations"
                  />
                </CustomAntStep>
              </div>
            );
          } else if (currentStep === 2) {
            return (
              <div>
                <H3>Approval Status</H3>
                <CustomAntStep current={2}>
                  <Step
                    title="Center Manager"
                    description="Submitted by Center Manager"
                  />
                  <Step
                    title="Operations Manager"
                    description="Approved by Operations Manager"
                  />
                  <Step
                    title="Assistant Director of Operations"
                    description="Awaiting Approval by Assistant Director of Operations"
                  />
                </CustomAntStep>
              </div>
            );
          } else if (currentStep === 3) {
            return (
              <div>
                <H3>Approval Status</H3>
                <CustomAntStep current={3}>
                  <Step
                    title="Center Manager"
                    description="Submitted by Center Manager"
                  />
                  <Step
                    title="Operations Manager"
                    description="Approved by Operations Manager"
                  />
                  <Step
                    title="Assistant Director of Operations"
                    description="Approved by Assistant Director of Operations"
                  />
                </CustomAntStep>
              </div>
            );
          }
        }
      } else {
        if (currentStep > 0) {
          if (currentStep === 1) {
            return (
              <div>
                <H3>Approval Status</H3>
                <CustomAntStep current={1}>
                  <Step
                    title={submittedBy !== "" ? submittedBy : ""}
                    description={`Submitted by ${
                      submittedBy !== "" ? submittedBy : ""
                    }`}
                  />
                  <Step
                    title="Assistant Director of Operations"
                    description="Awaiting Approval by Assistant Director of Operations"
                  />
                </CustomAntStep>
              </div>
            );
          } else if (currentStep === 2) {
            return (
              <div>
                <H3>Approval Status</H3>
                <CustomAntStep current={2}>
                  <Step
                    title={submittedBy !== "" ? submittedBy : ""}
                    description={`Submitted by ${
                      submittedBy !== "" ? submittedBy : ""
                    }`}
                  />
                  <Step
                    title="Assistant Director of Operations"
                    description="Approved by Assistant Director of Operations"
                  />
                </CustomAntStep>
              </div>
            );
          }
        }
      }
      break;

    case "AED_SAFE_ELT":
    case "HS_ELT":
    case "CASE_ELT":
      if (currentStep > 0) {
        if (currentStep === 1) {
          return (
            <div>
              <H3>Approval Status</H3>
              <CustomAntStep current={1}>
                <Step
                  title={`${submittedBy !== "" ? submittedBy : "Director"}`}
                  description={`Submitted by ${
                    submittedBy !== "" ? submittedBy : "Submitted by Director"
                  }`}
                />
                <Step
                  title="ELT Member"
                  description="Awaiting Approval by ELT Member"
                />
              </CustomAntStep>
            </div>
          );
        } else if (currentStep === 2) {
          return (
            <div>
              <H3>Approval Status</H3>
              <CustomAntStep current={2}>
                <Step
                  title={`${submittedBy !== "" ? submittedBy : "Director"}`}
                  description={`Submitted by ${
                    submittedBy !== "" ? submittedBy : "Submitted by Director"
                  }`}
                />
                <Step title="ELT Member" description="Approved by ELT Member" />
              </CustomAntStep>
            </div>
          );
        }
      }
      break;

    default:
      break;
  }
};

const CustomSteps = ({ role, approvals }) => {
  return getStepsByRole(role, approvals);
};

export default CustomSteps;
